import { PlayerNumber } from '~/modules/players/player-number';
import { useSubscription } from '~/modules/remote-mic/network/client/hooks/use-subscription';

export default function useColourOccupants(myMicId: string | null) {
  const list = useSubscription('remote-mics') ?? [];

  const occupants: Partial<Record<PlayerNumber, string>> = {};
  for (const mic of list) {
    if (mic.number !== null && mic.id !== myMicId) occupants[mic.number] ??= mic.name;
  }

  return occupants;
}
